import QuizrrErrorSvg from '../../../../apps/frontend/public/img/quizrr-error.svg';
import { ClockIcon } from '@phosphor-icons/react';

const MaintenancePage = () => {
  return (
    <div className="relative flex flex-col h-screen items-center justify-center gap-4">
      <p className="text-2xl md:text-4xl font-bold text-[var(--q3-accent-normal)] flex items-center justify-center gap-2">
        <ClockIcon /> Scheduled Maintenance
      </p>
      <p className="text-[var(--q3-neutral-light)] text-center text-sm md:text-base">
        We are upgrading our servers right now. The site will be accessible in sometime.
      </p>
      <div className="absolute bottom-0">
        <img src={QuizrrErrorSvg} alt="Quizrr" />
      </div>
    </div>
  );
};

export default MaintenancePage;
